import {v4 as uuidv4} from "uuid";

/**
 * Generates a random UUID (v4)
 * Uses native crypto.randomUUID() if available, falls back to uuid library
 * @returns A UUID string in the format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @example
 * generateUUID() // "550e8400-e29b-41d4-a716-446655440000"
 */
export function generateUUID(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    } else {
        return uuidv4();
    }
}
